import { beautyPreviewSeriesApi } from "../../../api/organizerBeautyApi";
import useSerieFija from "./useSerieFija";
import { previewEntries, seriesErrorMessage } from "./turnoFijoModel";

/* Turno fijo de la reserva nueva de Beauty: el estado común (useSerieFija) con la vista previa de POST /series/preview.
   La clave suma servicios, profesional y horario a la fecha, el intervalo y el fin. */
export default function useTurnoFijo({ items, professionalId, date, slotStart, completa }) {
  return useSerieFija({
    date,
    listo: Boolean(completa && items.length && professionalId && slotStart),
    claveParts: [professionalId, slotStart, JSON.stringify(items)],
    pedirVistaPrevia: async ({ intervalWeeks, dateTo }) => {
      const res = await beautyPreviewSeriesApi({ professionalId, items, date, slotStart, intervalWeeks, dateTo });
      const info = res?.data?.info || {};
      return { dates: previewEntries(info.dates), availableCount: info.availableCount };
    },
    mensajeDeError: (e) => seriesErrorMessage(e, "No pudimos revisar las fechas. Intentá de nuevo."),
  });
}
